import { Metadata } from 'aws-sdk/clients/s3';

export enum TempUploadStatus {
  pending = 'pending',
  processing = 'processing',
  done = 'done',
  error = 'error',
}

export enum CreateTempUploadSessionPayloadKeys {
  filePath = 'filePath',
  contentType = 'contentType',
  fileId = 'fileId',
  withThumbnail = 'withThumbnail',
  metadata = 'metadata',
}

export enum CreateTempUploadSessionResponseKeys {
  uploadId = 'uploadId',
  tempPath = 'tempPath',
  wasabiKey = 'wasabiKey',
  maxBytes = 'maxBytes',
  ttlHours = 'ttlHours',
}

export interface CreateTempUploadSessionPayload {
  [CreateTempUploadSessionPayloadKeys.filePath]: string;
  [CreateTempUploadSessionPayloadKeys.contentType]: string;
  [CreateTempUploadSessionPayloadKeys.fileId]?: string;
  [CreateTempUploadSessionPayloadKeys.withThumbnail]?: boolean;
  [CreateTempUploadSessionPayloadKeys.metadata]?: Metadata;
}

export interface CreateTempUploadSessionResponse {
  [CreateTempUploadSessionResponseKeys.uploadId]: string;
  [CreateTempUploadSessionResponseKeys.tempPath]: string;
  [CreateTempUploadSessionResponseKeys.wasabiKey]: string;
  [CreateTempUploadSessionResponseKeys.maxBytes]: number;
  [CreateTempUploadSessionResponseKeys.ttlHours]: number;
}
